export class SimpleCache {
  constructor() {
    this.cache = new Map()
  }

  async invoke(func, options = {}) {
    const { key: cacheKey, maxAgeInSeconds } = options
    if (!cacheKey) {
      throw new Error('missing cache key')
    }

    // Check if we have a cached entry
    if (this.cache.has(cacheKey)) {
      const entry = this.cache.get(cacheKey)
      const now = Date.now()
      const isExpired = maxAgeInSeconds !== undefined &&
          now > (entry.timestamp + maxAgeInSeconds * 1000)

      if (!isExpired) {
        return entry.data
      }
    }

    // Execute function and cache the promise
    const promise = func()
    const entry = { data: promise, timestamp: Date.now() }
    this.cache.set(cacheKey, entry)

    try {
      return await promise
    } catch (err) {
      // Remove failed promise from cache
      this.cache.delete(cacheKey)
      throw err
    }
  }

  purge(cacheKey) {
    this.cache.delete(cacheKey)
  }
}
